<template>
  <el-dialog :close-on-click-modal="false" title="邮寄地址" :visible.sync="isShow" width="500px">
    <el-form :model="formData" label-width="100px">
      <el-form-item label="收件人:">{{ formData.person }}</el-form-item>
      <el-form-item label="联系电话:">{{ formData.phone }}</el-form-item>
      <el-form-item label="所在地区:">{{ formData.province + formData.city + formData.county }}</el-form-item>
      <el-form-item label="详细地址:">{{ formData.fullAddress }}</el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="isShow = false">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { addressGetAddressById } from '@/api/crm.js'
export default {
  data () {
    return {
      isShow: false,
      formData: {}
    }
  },
  methods: {
    show (id) {
      this.isShow = true
      this.getAddressInfo(id)
    },
    getAddressInfo (id) {
      addressGetAddressById(id)
        .then(res => {
          if (res.data.success) {
            this.formData = res.data.data
          }
        })
    }
  }
}
</script>

<style>
</style>
